module.exports = __webpack_public_path__ + "img/FI22921572.20dab497.png";